import { BOGGLE_COMMON_LETTER_VALUES } from '~/boggle/config/challengeModLetterConstants'
import type { BoggleChallengeBoardDistributionDefinition } from '~/boggle/config/boardDistributions/boardDistributionDefinition'
import type { BoggleResolvedChallengeBoardDistribution } from '~/boggle/config/challenges/modTypes'
import { formatResolvedBoardDistributionDisplayFromDefinition } from '~/boggle/config/boardDistributions/formatResolvedBoardDistributionDisplay'

export const noCommonConsonantsBoardDistributionDefinition: BoggleChallengeBoardDistributionDefinition =
  {
    description: 'Common consonants will not appear',
    id: 'no-common-consonants',
    name: 'No Common Consonants',
    parameterDefinitions: {
      letters: {
        itemValues: BOGGLE_COMMON_LETTER_VALUES,
        kind: 'string-list',
        max: BOGGLE_COMMON_LETTER_VALUES.length,
        min: BOGGLE_COMMON_LETTER_VALUES.length,
      },
    },
    selectionWeight: 1,
    shortLabel: 'No TLRNS',
  }

export function resolveNoCommonConsonantsBoardDistribution(
  family: BoggleChallengeBoardDistributionDefinition,
  rngState: number,
): {
  mod: BoggleResolvedChallengeBoardDistribution
  rngState: number
} {
  const parameters = {
    letters: {
      definition: family.parameterDefinitions.letters!,
      value: BOGGLE_COMMON_LETTER_VALUES,
    },
  }
  const display = formatResolvedBoardDistributionDisplayFromDefinition(family, parameters)

  return {
    mod: {
      description: display.description,
      effects: BOGGLE_COMMON_LETTER_VALUES.map(letter => ({
        kind: 'letter-weights' as const,
        transform: {
          kind: 'remove-letter' as const,
          letter,
        },
      })),
      familyId: family.id,
      id: family.id,
      name: display.name,
      outcomes: BOGGLE_COMMON_LETTER_VALUES.map(letter => ({
        kind: 'blocked-letter' as const,
        letter,
      })),
      parameters,
      shortLabel: display.shortLabel,
    },
    rngState,
  }
}
